import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: null, status: 'idle', error: null };

const familySearchSlice = createSlice({
  name: 'familySearch',
  initialState,
  reducers: {
    familySearchRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    familySearchSuccess(state, action) {
      state.status = 'succeeded';
      state.data = action.payload;
    },
    familySearchFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    familySearchReset(state) {
      state.status = 'idle';
      state.error = null;
      state.data = null;
    },
  },
});

export const familySearchAction = familySearchSlice.actions;
export default familySearchSlice;